import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=a0d9afb0&scoped=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=a0d9afb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d9afb0",
  null
  
)

export default component.exports